import { render, staticRenderFns } from "./general-claims.vue?vue&type=template&id=00397c1c&"
import script from "./general-claims.vue?vue&type=script&lang=js&"
export * from "./general-claims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports